/** QuickHouse — Composant racine : sélecteur de projet puis éditeur complet */
import { useProjectStore } from './store/useProjectStore.js';
import ProjectPicker from './components/ProjectPicker.jsx';
import Toolbar from './components/Toolbar.jsx';
import FloorBar from './components/FloorBar.jsx';
import StatusBar from './components/StatusBar.jsx';
import CanvasEditor from './editor2d/CanvasEditor.jsx';
import Viewer3D from './viewer3d/Viewer3D.jsx';
import RightPanel from './components/RightPanel.jsx';
import Ribbon from './components/Ribbon.jsx';

export default function App() {
  const project = useProjectStore((s) => s.project);
  const viewMode = useProjectStore((s) => s.viewMode);
  const setViewMode = useProjectStore((s) => s.setViewMode);
  const closeProject = useProjectStore((s) => s.closeProject);
  const saveState = useProjectStore((s) => s.saveState);

  if (!project) return <ProjectPicker />;

  return (
    <div className="app">
      <div className="topbar">
        <h1>Quick<span className="logo-sfx">·House</span></h1>
        <button onClick={closeProject} title="Retour aux projets">←</button>
        <span className="project-name">{project.name}</span>
        <span className={`save-state ${saveState === 'error' ? 'error' : ''}`}>
          {saveState === 'saving' ? '💾 Sauvegarde…' : saveState === 'saved' ? '✓ Sauvegardé' : saveState === 'error' ? '⚠ Erreur de sauvegarde' : ''}
        </span>
        <span className="spacer" />
        <div className="tabs">
          <button className={viewMode === '2d' ? 'active' : ''} onClick={() => setViewMode('2d')}>Plan 2D</button>
          <button className={viewMode === '3d' ? 'active' : ''} onClick={() => setViewMode('3d')}>Vue 3D</button>
        </div>
      </div>
      {viewMode === '2d' && <Ribbon />}
      <FloorBar />
      <div className="main">
        {viewMode === '2d' && <Toolbar />}
        <div className="canvas-area">
          {viewMode === '2d' ? <CanvasEditor /> : <Viewer3D />}
        </div>
        <RightPanel />
      </div>
      <StatusBar />
    </div>
  );
}
